export enum steps {
  CURRENT = 'auth.updatePassword.steps.step1',
  NEW = 'auth.updatePassword.steps.step2',
  COMPLETE = 'auth.updatePassword.steps.complete',
}
